import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { fetchContentItemProjectAccess } from '@/api/v4/content-items.api';
import { useNavigateTo } from '@/routes/hooks/use-navigate-to';
import { notify } from '@/ui/snackbar/notify';

export const useGoToProjectFromFeed = () => {
  const { t } = useTranslation('feed', { keyPrefix: 'card' });
  const navigateTo = useNavigateTo();

  const mutation = useMutation({
    mutationFn: fetchContentItemProjectAccess,
    onSuccess: data => {
      if (data.hasAccess && data.projectId) {
        navigateTo.project({ projectId: data.projectId });
        return;
      }

      notify({
        message: data.projectId
          ? t`projectAccessDenied`
          : t`projectUnavailable`,
      });
    },
    onError: () => {
      notify({ message: t`projectUnavailable` });
    },
  });

  return {
    goToProject: mutation.mutateAsync,
    isPending: mutation.isPending,
  };
};
